import { render, staticRenderFns } from "./CallLogCustomerDetails.vue?vue&type=template&id=3f347cdd"
import script from "./CallLogCustomerDetails.vue?vue&type=script&lang=js"
export * from "./CallLogCustomerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports